import React from 'react'
import SEO from 'components/atoms/seo'
import Container from 'components/atoms/Container'
import { Text, H6 } from 'components/atoms/Typography'
import { Box } from 'components/atoms/Layout'
import Hero from 'components/molecules/Hero'
import GenericPage from 'routes/components/pages/GenericPage'

const FAQ = () => (
  <GenericPage>
    <SEO title="FAQ" />
    <Hero>FAQ</Hero>
    <Container.Narrow>
      <Box mb="xl">
        <Text.Block gutter="l">
          <div>
            <H6>How does NuNu work?</H6>
            <Text>
              It is a no-money down program where the loan received covers the
              full purchase price of your home. (Providing the appraisal meets
              valuation required)
            </Text>
          </div>
          <div>
            <H6>How do I apply?</H6>
            <Text>
              Using our website, you can apply for a loan amount in minutes.
              Just click on the “See if I Qualify Button.” If you need
              additional assistance, you can always reach us at 1-866-BUY-NUNU
              (289-6868).
            </Text>
          </div>
          <div>
            <H6>How do I choose my dream home?</H6>
            <Text>
              Once we determine the loan amount you are qualified for; we can
              refer you to a real estate agent that will assist you in finding
              your dream home. Or, you can use your own Real Estate agent.
            </Text>
          </div>
          <div>
            <H6>What is the interest rate?</H6>
            <Text>
              The interest rate varies based on your credit score, call your
              NuNu Home Loan Expert for details
            </Text>
          </div>
          <div>
            <H6>What will be my closing costs?</H6>
            <Text>
              Closing costs vary based on the loan amount of the home. NuNu
              allows you the option to finance closing costs into the loan. This
              information will be detailed in the Loan Estimate form that will
              be provided once a complete loan application is submitted.
            </Text>
          </div>
          <div>
            <H6>
              What is the minimum amount of money I must prepare for the
              closing?
            </H6>
            <Text>
              Since the program allows you to finance all closing costs, the
              minimum amount of funds that will be required at closing time is
              only equal to 2 monthly mortgage payments.
            </Text>
          </div>
          <div>
            <H6>In what locations does NuNu operate?</H6>
            <Text>
              At the moment NuNu currently operates in the state of Florida.
            </Text>
          </div>
        </Text.Block>
      </Box>
    </Container.Narrow>
  </GenericPage>
)

export default FAQ
